// extracted by mini-css-extract-plugin
export default {"Summary":"Summaries_Summary__Pcmka"};